import { gql } from "@apollo/client";

export const ENDPOINT_QUERY = gql`
  query Endpoint($network: Network!, $projectId: ID!, $chain: Chain) {
    endpoint: endpoint(
      network: $network
      projectId: $projectId
      chain: $chain
      archive: false
      websocket: false
    ) {
      id
      projectId
      url
    }
    endpointArchive: endpoint(
      network: $network
      projectId: $projectId
      chain: $chain
      archive: true
      websocket: false
    ) {
      id
      projectId
      url
    }
    endpointWebsocket: endpoint(
      network: $network
      projectId: $projectId
      chain: $chain
      archive: false
      websocket: true
    ) {
      id
      projectId
      url
    }
    endpointArchiveWebsocket: endpoint(
      network: $network
      projectId: $projectId
      chain: $chain
      archive: true
      websocket: true
    ) {
      id
      projectId
      url
    }
  }
`;

export const CREATE_ENDPOINT_MUTATION = gql`
  mutation CreateEndpoint($network: Network!, $projectId: ID!, $archive: Boolean, $websocket: Boolean, $chain: String) {
    createEndpoint(network: $network, projectId: $projectId, archive: $archive, websocket: $websocket, chain: $chain) {
      id
      chain
      network
      projectId
      url
      archive
      websocket
      dedicated
    }
  }
`;

export const UPDATE_ENDPOINT_CORS_MUTATION = gql`
  mutation UpdateEndpointCORS(
    $allowOrigins: [String!]!
    $network: Network!
    $projectId: ID!
    $archive: Boolean
    $websocket: Boolean
    $chain: Chain
  ) {
    updateEndpointCORS(
      allowOrigins: $allowOrigins
      network: $network
      projectId: $projectId
      archive: $archive
      websocket: $websocket
      chain: $chain
    ) {
      allowOrigins
      id
      network
      projectId
      url
    }
  }
`;
export const ENDPOINT_METRICS_QUERY = gql`
  query EndpointMetrics(
    $network: Network!
    $projectId: ID!
    $archive: Boolean
    $chain: Chain
    $interval: String
    $showLast: TimeRange
  ) {
    endpointMetrics(
      network: $network
      projectId: $projectId
      archive: $archive
      chain: $chain
      interval: $interval
      showLast: $showLast
    ) {
      count
      timestamp
    }
  }
`;

export const ENDPOINT_RPC_METHODS_METRICS_QUERY = gql`
  query EndpointMetricsByCall(
    $network: Network!
    $projectId: ID!
    $archive: Boolean
    $chain: Chain
    $interval: String
    $showLast: TimeRange
  ) {
    endpointMetricsByCall(
      network: $network
      projectId: $projectId
      archive: $archive
      chain: $chain
      interval: $interval
      showLast: $showLast
    ) {
      data {
        count
        timestamp
      }
      group
      count
    }
  }
`;

export const ENDPOINT_RPC_ORIGIN_METRICS_QUERY = gql`
  query EndpointMetricsByOrigin(
    $network: Network!
    $projectId: ID!
    $archive: Boolean
    $chain: Chain
    $interval: String
    $showLast: TimeRange
  ) {
    endpointMetricsByOrigin(
      network: $network
      projectId: $projectId
      archive: $archive
      chain: $chain
      interval: $interval
      showLast: $showLast
    ) {
      data {
        count
        timestamp
      }
      group
      count
    }
  }
`;

export const ENDPOINT_RPC_REGION_METRICS_QUERY = gql`
  query EndpointMetricsByRegion(
    $network: Network!
    $projectId: ID!
    $archive: Boolean
    $chain: Chain
    $showLast: TimeRange
  ) {
    endpointMetricsByRegion(
      network: $network
      projectId: $projectId
      archive: $archive
      chain: $chain
      showLast: $showLast
    ) {
      count
      group
    }
  }
`;

export const ENUM_VALUES_QUERY = gql`
  query {
    network: __type(name: "Network") {
      enumValues {
        label: name
        value: name
      }
    }

    chain: __type(name: "Chain") {
      enumValues {
        label: name
        value: name
      }
    }
  }
`;
